export const CLEANING_TYPE_CLEANING_REPORT = 'cleaning';
export const CLEANING_CAR_STATUS_RUNNING = 'running';
export const CLEANING_CAR_STATUS_WORKING = 'working';
export const CLEANING_CAR_STATUS_STOPPED = 'stopped';
